import { Rect } from 'react-konva'
import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { commonShapeProps, ShapeInteraction } from './shapeInteraction'

type Props = {
  shape: Extract<VisualShape, { type: 'rect' }>
  width: number
  height: number
  interaction?: ShapeInteraction
}

const RectShape = ({ shape, width, height, interaction }: Props) => {
  const centerX = shape.x * width
  const centerY = shape.y * height
  const pixelWidth = shape.width * width
  const pixelHeight = shape.height * height

  return (
    <Rect
      ref={interaction?.nodeRef}
      x={centerX}
      y={centerY}
      width={pixelWidth}
      height={pixelHeight}
      offsetX={pixelWidth / 2}
      offsetY={pixelHeight / 2}
      rotation={shape.rotation ?? 0}
      fill={shape.fill_rgb}
      {...commonShapeProps(shape)}
      draggable={interaction?.draggable ?? false}
      listening={interaction !== undefined}
      onMouseEnter={interaction?.onMouseEnter}
      onMouseLeave={interaction?.onMouseLeave}
      onMouseDown={interaction?.onMouseDown}
      onTap={interaction?.onTap}
      onDragStart={interaction?.onDragStart}
      onDragMove={interaction?.onDragMove}
      onDragEnd={interaction?.onDragEnd}
    />
  )
}

export default RectShape
